var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _polygon3, _path24, _path25, _polygon4, _path26, _path27, _rect, _path28, _polygon5, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvtalatLogo25Clr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 704.2 205.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #008d97;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.6,34.6h20.6v27.8h-20.6v40.6c0,.2,1,3.6,1.2,4.1,2.9,7.6,9.9,9.2,17,6.5,1.7-.6,2.7-2.7,4.8-.9l8.9,19.4c.5,3.1-5.2,5.4-7.6,6.4-11.9,5-26.8,4.6-38.1-1.9-25.6-15-16-49.4-17.9-74h-15.6c-2.6,0-6.4,5.7-7.4,8l-29.2,68.8-26.1-.2-19.6-45.7c-3.6-5-6.3-5.9-12.1-3.7-1.6.6-12.7,5.6-12.9,6.3l17.1,40.4c.4,1.3-.6,2.3-1.7,2.9h-30.8s-12.4-31.1-12.4-31.1c-16.4,7-32.7,14.3-49,21.5-13.1,5.9-23.5,13.2-38.8,12.1-3.4-.2-13.6-2.4-14.4-6.2l4.5-22c1.7-2.9,4.1,0,6.6-.1,3.9,0,6.2-4,8-6.9L63.9,6.4l28,.4,27.6,64.8c13.9-5.5,25.6-13.9,41.4-9.9,17,4.3,22.4,25.7,27.3,40.2l1.1-.6c6-14.3,10.8-29.3,16.9-43.5,4.2-9.6,11.8-23.1,24-23.1h22.8V8.4c.8-.9,2.4-.9,3.7-1.1,8.2-1.4,16.7-1.8,24.9-3.4.6,0,3.1,1.3,3.1,1.6v29h0ZM92.6,84l-14.8-37.9-20.7,53.3,35.5-15.4h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M404.2,47.6v-10.6h25.7l.7.7v72.5c0,.4,1.4,3,2,3.3,2.5,1,6.2-1.2,7.3.8l3.6,20.4c.1,3.5-4.5,4.8-7.3,5.7-12.5,3.8-26.2.5-31.6-12.1-22.3,20.9-59,17.4-76.2-8-17.2-25.4-10.8-64.3,16.9-79.4,19-10.5,42.7-7.4,58.9,6.8h0ZM371.4,62.1c-28.7,3.9-26.8,54.6,6.1,52.7,33.1-1.9,31.1-57.7-6.1-52.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M588.5,47.6v-10.6h25.9v70.8c0,.3.7,3,.8,3.5,1.8,5.1,7.6.5,9,3l3.6,20.4c0,3.6-4.5,4.8-7.3,5.6-12.1,3.6-26.7.7-31.6-12.1-28.4,25.8-73.6,13.4-83.8-24-9.6-35.4,13.9-71.9,52.3-69.6,11.6.7,22.1,5.8,30.9,13h0ZM555.7,62.1c-15.1,1.9-22.3,17.9-19.9,31.7,4.9,27.8,43.7,28,48.7.5,3.5-19.2-8.7-34.7-28.8-32.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M672,34.6h21.1v27.1l-.7.7h-20.4v39.1c0,.3.7,2.9.8,3.5,2.3,8.6,8.8,11.5,17.1,8.6,2-.7,3.6-2.7,5.4-.8l8.8,19.4c0,3.4-7.3,6.2-10.1,7.1-25.2,8.5-51.1-5.1-53.2-32.5V7.7s28.2-3.8,28.2-3.8c.6-.3,3,1.5,3,1.7v29h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.8,113.9c1.4,1.7,2.8,17.9,4,21.2-.4,3.9-10.4,6.2-13.7,6.5-19.5,1.7-30.3-8.4-31.5-27.6l.3-110.2L481.2,0c1.3-.2,3.6.4,4,1.8v106.5c.3,1.1.5,2.5,1,3.5,2.1,4.3,7.1.4,8.6,2.2h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "135.4 178.6 141.5 178.7 151.7 193 151.7 178.6 158.4 178.6 158.4 204.5 152.4 204.1 142.1 190.1 142.1 204.5 135.4 204.5 135.4 178.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.2,178.6h6.1c0,.1,10.2,14.4,10.2,14.4v-14.4h6.7v25.9l-6-.4c-1.7-1.4-9.2-13.7-10-14-1.1-.3-.7.7-.7,1.2-.4,4.1,1.3,8.6.3,12.8l-6.5.4v-25.9h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442.6,178.6h6.1c0,.1,10.2,14.4,10.2,14.4v-14.4h6.7v25.9c-1.9-.2-4.4.5-6-.4-1.4-.9-7.9-11.1-9.7-13.4-.3-.4,0-.9-1.1-.6v14.4h-6.2v-25.9h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.9,178.3c7-1,13.9,1.3,16.1,8.6,2.5,8.3-1.8,17.3-11,18.1-19.7,1.9-20.3-24.6-5.1-26.8h0ZM182.8,184c-8,1.3-7.7,15.2,1.2,15.1,9.6-.2,8.9-16.7-1.2-15.1h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.1,178.3c7.2-1,13.8,1.3,16.1,8.6,3.2,10.5-3.8,19.1-14.8,18.1-15.7-1.4-15.3-24.7-1.3-26.8ZM117,184c-9.3,1.5-6.6,18.7,4.3,14.4,6.3-2.5,4.9-15.9-4.3-14.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.8,178.3c11-1.6,18.6,5.7,16.3,16.8-1.5,7.2-7.9,10.6-15,10-15.8-1.5-15.4-24.7-1.3-26.8ZM291.2,184c-7,1.3-7.4,14.9,1.4,15.1,10,.2,9.3-17-1.4-15.1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M598.9,178.2c10.8-1.7,18.2,5,16.9,16-1.7,15.1-29.2,15.4-26.9-5.3.6-5.1,4.9-9.9,10-10.7h0ZM600.8,184c-7.4,1.3-7.3,14.9,1.4,15.1,10,.2,9-16.9-1.4-15.1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M632.4,178.6c1.8.3,4.6,2.6,5.2,4.4,1.2,3.7-.3,6.3-3,8.6,5.1,1.1,5.7,7.7,1.9,10.8-.8.7-4.2,2.1-5.1,2.1h-12l-.7-.7v-25.2c4.2.5,9.7-.7,13.7,0h0ZM630.6,184.5c-1-.9-3.8-.5-5.2-.6v4.8c2.3-.2,5.5,1,5.8-2.2,0-.6-.2-1.6-.6-2h0ZM625.4,199.3c8.9,1.2,9-6.7,0-5.3v5.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M655,178.6c6.8,1,8,9.2,2.6,12.9,5.8,1.5,5.6,9.3.5,11.8-.4.2-3.4,1.2-3.6,1.2h-12l-.7-.7v-25.2c4.1.4,9.2-.6,13.2,0h0ZM648.5,188.7c8,1.4,7.6-6,0-4.8v4.8ZM648.5,199.3c8.7,1.2,9-6.8,0-5.3v5.3Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "230.9 178.6 230.9 188.2 241 188.2 241 178.6 247.7 178.6 247.7 204.5 241 204.5 241 194.4 230.9 194.4 230.9 204.5 224.2 204.5 224.2 178.6 230.9 178.6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.7,204.5h-7.2c-2.1-3.2-2.8-9.3-7.7-8.2v8.2h-6.2v-25.9h13.2c.7,0,4.1,1.8,4.8,2.4,2.9,2.6,3,8.4.9,11.5-.6.9-2.6,2.1-2.5,3.1l4.7,9h0ZM412.8,190.6c9.9,1.6,9.9-7.9,0-6.2v6.2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.7,204.5h-7.2c-2-3.2-2.7-9.4-7.7-8.2v8.2h-6.2v-25.9h13.2c.4,0,3.8,1.5,4.3,1.9,2.9,2.1,3.3,6.8,2.4,10.1-.5,1.9-3.6,4-3.5,4.9l4.7,9h0ZM315.8,190.6c9.9,1.6,9.9-7.9,0-6.2v6.2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.4,178.6v9.6c.9-.1,2.6.3,3.3-.1.9-.5,4.2-8.3,5.6-9.5h7.4l-7.5,12.7c0,1,6.2,9.6,7.1,11.5.3.6.6,1,.5,1.7h-7c-2.2-1.8-4.3-8.2-6.2-9.6-.9-.7-3.1-.6-3.1.3v9.4h-6.2v-25.9h6.2,0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M491.5,203.6c-8.3,2.8-19.1,2.1-21.9-7.7-3.9-13.8,9.1-21.6,21.1-16.4l.2,5.8c-5.1-1.6-12.8-2.9-14.7,3.7s3.3,11.9,9.5,9v-7.4h5.8v13Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M539,204.5l9.3-25.9h6.9c0,.1,8.7,26,8.7,26h-6.7l-1.2-4.3-8.9-.2-1.4,4.6h-6.7ZM552,186.3c-1.3-.1-.8,0-1,.7-.3.9-2.2,6.7-1.9,7h4.8l-1.9-7.7h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.8,204.5l9.1-25.7,7.5.2,8.9,25.4-6.7-.2-1.7-4.6-8.9.3-1.4,4.5h-6.7,0ZM369.1,194c-1-2.1-1.4-4.5-2.2-6.7-.2-.5,0-1.1-.7-1l-2.4,7.7h5.3,0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.8,185.8c-.4.4-11.1-4.8-11.5-.2-.2,2.6,6.5,3.4,8.5,4.4,4.1,2.1,5.3,6.2,3.5,10.4-2.8,6.3-13.9,5.2-18.9,2.2l-.2-6.2c2.1,1.5,12.6,5.1,13,.7-.4-2.9-5-2.9-7.5-4-8.1-3.6-6.5-14,2-15,2.6-.3,6.7,0,9.1.9,3.6,1.5,1.8,3.4,2.1,6.7h0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.8,185.8c-.4.4-11.1-4.8-11.5-.2-.2,2.6,6.5,3.4,8.5,4.4,6.4,3.2,5.6,12.2-1.2,14.4-4.4,1.4-10.3.4-14.3-1.8l-.2-6.2c2.1,1.5,12.6,5.1,13,.7-.5-3-5.3-2.9-7.9-4.1-4-1.9-5.2-4.4-4.6-8.8.8-6.9,11.2-7.1,16.1-5,3.6,1.5,1.8,3.4,2.1,6.7h0Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.7,197.3v7.2H0v-25.9h12.7c3.5,0,6.9,4.1,7.4,7.5,1.2,9-5.6,12-13.4,11.2ZM6.7,184.4v7.2c9.1,1.4,9.3-8.8,0-7.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.8,178.6v5.3h-10.1v4.8h9.1c-.2,1.9.7,4.4-.7,5.8h-8.4v4.3h10.1v5.8h-16.8v-25.9h16.8Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "681.6 178.6 681.6 183.9 671.5 183.9 671.5 188.7 680.6 188.7 680.6 194.4 671.5 194.4 671.5 198.8 681.6 198.8 681.6 204.5 665.5 204.5 664.8 203.8 664.8 178.6 681.6 178.6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.8,178.6l5.8,18.2,6.2-18.2h6.7l-8.7,25.2c-1.1,1.6-5.5.4-7.4.8l-9.8-25.9h7.2Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.2,179.2v6.2c-5.7-2.3-14.1-1.3-13.9,6.5s8.4,8,13.9,6v6.2c-8.7,2.8-18.8,0-20.4-10-2-12.6,9.4-18.8,20.4-14.8h0Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "277.9 178.6 277.9 183.9 267.4 183.9 267.4 188.7 276.5 188.7 276.5 194.4 267.4 194.4 267.4 204.5 261.1 204.5 261.1 178.6 277.9 178.6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M704.2,178.6v6.2h-6.7v19c-1.7,1.5-4.6.4-6.7.7v-19.7h-6.7v-6.2h20.2,0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M585.6,178.6v19c0,.3-1,3.1-1.2,3.6-2.1,4.1-7.2,4.3-11.2,3.4v-6.2c1.7,1.2,5.7-.2,5.7-2.2v-17.5h6.7Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 94.6,
    y: 178.6,
    width: 6.7,
    height: 25.9
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M536.6,178.6v25.2c-1.7,1.5-4.6.4-6.7.7v-25.9h6.7Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "431 178.6 437.3 178.6 437.5 204.1 431 204.5 431 178.6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.5,169.6c5-1,6.2,6.5,1.2,7-4.7.4-5.5-6.1-1.2-7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.1,176.1c-3.1,3.2-8.9-1.3-5.7-4.9s8.6,1.8,5.7,4.9Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.9,169.6c5-1,6.2,6.5,1.2,7-4.5.4-5.6-6.1-1.2-7Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M370.4,170.1c3.9-.4,5.7,4.8,2.2,6.6-5.3,2.7-7.9-6-2.2-6.6Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.2,184c10.7-1.9,11.4,15.3,1.4,15.1-8.8-.2-8.4-13.8-1.4-15.1Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.8,190.6v-6.2c9.9-1.6,9.9,7.9,0,6.2Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.8,190.6v-6.2c9.9-1.6,9.9,7.9,0,6.2Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.1,194h-5.3l2.4-7.7c.6-.1.5.5.7,1,.8,2.2,1.1,4.6,2.2,6.7h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvtalatLogo25Clr);
export default __webpack_public_path__ + "static/media/avtalat-logo25_clr.a845bd3040cf554f6f324c565c4c4ed6.svg";
export { ForwardRef as ReactComponent };